import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import ConfigurationProfileDialog from "../profile/ConfigurationProfileDialog";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Portal from "@material-ui/core/Portal";
import ErrorMessageDialog, { useErrorMessageDialog } from "../dialog/ErrorMessageDialog";
import * as Utils from "../../Utils";
import * as Config from "../utils/ConfigurationRegistry";
var SaveConfigurationButton = function SaveConfigurationButton(_ref) {
  var label = _ref.label,
    singleProfile = _ref.singleProfile,
    profileLabel = _ref.profileLabel,
    PermissionConfigurationComponent = _ref.PermissionConfigurationComponent,
    doNotWarnUserOfPendingEdits = _ref.doNotWarnUserOfPendingEdits,
    url = _ref.url,
    handleResponse = _ref.handleResponse,
    forceClick = _ref.forceClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    notification = _useState4[0],
    setNotification = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    requestPending = _useState6[0],
    setRequestPending = _useState6[1];
  var _useErrorMessageDialo = useErrorMessageDialog(),
    _useErrorMessageDialo2 = _slicedToArray(_useErrorMessageDialo, 2),
    errorMessage = _useErrorMessageDialo2[0],
    setErrorMessage = _useErrorMessageDialo2[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    saveStateCount = _useState8[0],
    setSaveStateCount = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    saveConfigurationTrigger = _useState10[0],
    setSaveConfigurationTrigger = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isConfigEdited = _useState12[0],
    setIsConfigEdited = _useState12[1];
  useEffect(function () {
    if (forceClick) {
      handleClickSave();
    }
  }, [forceClick]);
  useEffect(function () {
    if (notification && !notification.success) {
      setErrorMessage(createErrorMessage(notification.messages));
    }
  }, [notification]);
  var createErrorMessage = function createErrorMessage(messages) {
    if (!messages) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "textPrimary"
    }, "Please correct the following problems before continuing:"), /*#__PURE__*/React.createElement("p", null), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, /*#__PURE__*/React.createElement("ul", null, messages.map(function (message, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, message);
    }))));
  };
  var issueSaveRequest = function issueSaveRequest() {
    if (!requestPending) {
      setRequestPending(true);
      Utils.fetchData(url ? url : "configuration/save", {
        method: "post",
        body: JSON.stringify({
          values: Config.buildConfigurationValueDtos()
        })
      }).then(function (data) {
        setRequestPending(false);
        if (handleResponse) {
          handleResponse(data);
        } else {
          data.open = true;
          setNotification(data);
        }
      }).catch(function (response) {
        setRequestPending(false);
        Utils.getErrorMessage(response, "Save failed.").then(function (message) {
          return setNotification({
            success: false,
            messages: [message],
            open: true
          });
        });
      });
    }
  };
  var closeNotification = function closeNotification() {
    if (notification) {
      var notificationClone = _objectSpread({}, notification);
      notificationClone.open = false;
      setNotification(notificationClone);
    }
  };
  var handleClickSave = function handleClickSave() {
    if (!requestPending) {
      if (singleProfile) {
        issueSaveRequest();
      } else {
        setOpen(true);
      }
    }
  };

  //
  // Timer controls to show the save button if the configuration has been edited
  // 
  React.useEffect(function () {
    var interval = setInterval(function () {
      setSaveStateCount(function (prevCount) {
        return prevCount + 1;
      });
    }, 1000);
    return function () {
      return clearInterval(interval);
    }; // cleanup on unmount
  }, []); // no dependencies

  useEffect(function () {
    setIsConfigEdited(Config.isEdited());
  }, [saveStateCount]);

  // Sets the trigger that fires up the save command in the child component
  var handleClickSavePending = function handleClickSavePending() {
    setSaveConfigurationTrigger(function (prevCount) {
      return prevCount + 1;
    });
  };

  //

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorMessageDialog, errorMessage), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Snackbar, {
    open: notification && notification.open && notification.success,
    autoHideDuration: 6000,
    onClose: closeNotification
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: closeNotification,
    severity: notification && notification.success ? "success" : "error"
  }, notification && notification.messages && notification.messages[0]))), /*#__PURE__*/React.createElement(ConfigurationProfileDialog, {
    open: open,
    profileLabel: profileLabel,
    readOnly: false,
    doNotWarnUserOfPendingEdits: doNotWarnUserOfPendingEdits,
    handleClose: function handleClose() {
      return setOpen(false);
    },
    handleNotification: setNotification,
    PermissionConfigurationComponent: PermissionConfigurationComponent,
    saveConfigurationTrigger: saveConfigurationTrigger
  }), isConfigEdited && /*#__PURE__*/React.createElement(Button, {
    style: {
      color: 'red'
    },
    startIcon: /*#__PURE__*/React.createElement(SaveIcon, null),
    onClick: handleClickSavePending
  }, "*"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleClickSave,
    startIcon: requestPending ? /*#__PURE__*/React.createElement(CircularProgress, {
      color: "inherit",
      size: 20
    }) : /*#__PURE__*/React.createElement(SaveIcon, null)
  }, label || "Save"));
};
export default SaveConfigurationButton;